import { Stack } from '@resi-media/resi-ui';
import { useAtomValue } from 'jotai';
import { HeaderlessContent } from '@studio/components/HeaderlessContent';
import { LogoHeader } from '@studio/components/LogoHeader';
import Loading from '@studio/pages/Loading';
import { errorAtom, isExpiredAtom, isLoadingAtom, isRefreshingAtom } from '@preview/store/auth';
import LoginForm from './components/LoginForm';

const LoginPage = () => {
  const error = useAtomValue(errorAtom);
  const isExpired = useAtomValue(isExpiredAtom);
  const isLoading = useAtomValue(isLoadingAtom);
  const isRefreshing = useAtomValue(isRefreshingAtom);

  return (
    <HeaderlessContent>
      {isRefreshing ? (
        <Loading />
      ) : (
        <Stack alignItems="center" dataTestId="wrapper">
          <LogoHeader />
          <LoginForm error={error} isLoggingIn={isLoading} sessionExpired={isExpired} />
        </Stack>
      )}
    </HeaderlessContent>
  );
};

LoginPage.displayName = 'LoginPage';

export default LoginPage;
